export const SITE = {
  name: "Victoria Fuentes",
  role: "Psicóloga Sanitaria",
  colegiada: "AO-12347",
  colegio: "Colegio Oficial de Psicología de Andalucía Oriental (COP-AO)",
  nif: "76435051W",
  phone: "613191818",
  phoneDisplay: "613 19 18 18",
  whatsapp: "34613191818",
  email: "victoriafuentespsicologa@gmail.com",
  address: "C/ Eslava 14, 2ª planta, oficina 7",
  city: "Málaga",
  postalCode: "29002",
  region: "Andalucía",
  country: "España",
  schedule: "Lunes a Viernes · 9:00–14:00 y 16:00–20:00",
  mapsQuery: "Calle Eslava 14, Málaga",
  doctoralia: "",
  url: typeof window !== "undefined" ? window.location.origin : "",
};

export const NAV = [
  { label: "Inicio", to: "/" },
  { label: "Sobre mí", to: "/sobre-mi" },
  {
    label: "Servicios",
    children: [
      { label: "Ansiedad", to: "/psicologa-ansiedad-malaga" },
      { label: "Depresión", to: "/psicologa-depresion-malaga" },
      { label: "Duelo", to: "/psicologa-duelo-malaga" },
      { label: "Psicología perinatal", to: "/psicologa-perinatal-malaga" },
      { label: "Niños y adolescentes", to: "/psicologa-infantil-malaga" },
    ],
  },
  { label: "Contacto", to: "/contacto" },
];

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/7817490e0278a10da37201d50af2a234efe8920a73c0907a8679b89fcdbb5340.jpeg",
  portrait: "https://customer-assets-jt897jd0.emergentagent.net/job_consulta-sanitaria-1/artifacts/mvlnlf82_Foto%20consulta.webp",
  clinic: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/db2f31eeebcf744a45d9bd099296d5d50aee5c1c2239c81b744facc719b8ed90.jpeg",
  cta: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/dd88cb3855b10e40dcf1b7bef42d7c726a379f685a8b5dd3866e11d65ad7b54d.jpeg",
  blog: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/3f59e40fb857f30702b56655efb30d1b3cb66725892fb757a1b53689bc1ffce2.jpeg",
  ansiedad: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/c5f22bec879a14f04862ec5349db34fc0ce90635d04933cf9a8fced5baca5b2e.jpeg",
  depresion: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/3029a8fcf3559bef7f03372341f5612359721dcc1b9ec38a47aa3098f51f83d0.jpeg",
  duelo: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/c3dd9a2b19a96fcb443df475bc8eccd94fb2830d478af491278f3481f23d5772.jpeg",
  perinatal: "https://static.prod-images.emergentagent.com/jobs/8ab517d1-955f-4652-9297-577ec4f8ee26/images/ac124bf2a787f59def902630ead1f86183c943a1f790cbfb4fd33a152f45caee.jpeg",
  infantil: "/images/psicologa-infantil-malaga-ninos-adolescentes.webp",
};

export const waLink = (text = "Hola Victoria, me gustaría pedir una primera cita.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;
